import * as moment from 'moment';
import { Dispatch, connect } from 'react-redux';
import { AppActionCreators, DashCenterActionCreators, IApplicationState, ICenterDashDetailResponse, IPwlDetails, IPwlDetailsResponse, IRegistrationDetailsForPwl, IResultsUploaded, IShippedJug, IUploadLabsResponse } from '@nkr/store/index';
import { IBaseResponse, IDonorRegistration } from '@nkr/models/index';
import { useEffect, useReducer, useState } from 'react';
import { Alert, Col, DropdownButton, Label, MenuItem, Panel, Row, Table } from 'react-bootstrap';
import styled from 'styled-components';
import { PreWorkupLabJugStatus, PreWorkupLabStep } from '@nkr/enums/index';
import { downloadFile } from '@nkr/services/download-file';
import { toast } from 'react-toastify';
import MarkJugArrivedSendEmail from '../components/all/mark-jug-arrived-send-email';
import { initialState, PwlActions, pwlDetailsReducer } from './state';
import { AxiosError } from 'axios';
import ReadyForLabsModal from './ready-for-labs-modal';
import UploadScrip from './upload-scrip-modal';
import UploadLabResults from './upload-lab-results-modal';
import ConvertToDirectToCenterModal from './convert-to-direct-to-center-modal';
import MarkResultsReviewedModal from './mark-results-reviewed-modal';
import RestartPwlModal from './restart-pwl-modal';
import RuleOutModal from './rule-out-modal';
import ExpireDonorModal from './expire-donor-modal';

const TableWrapper = styled(Table)`
    margin-bottom: 0px;

    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
    }
`;

interface IOwnProps {
    registrationId: number,
    centerId: number,
    isAdmin: boolean
}

interface IStateProps {
    groupIsSuper: boolean
}

interface IDispatchProps {
    showLoading: (message) => Promise<void>,
    hideLoading: () => void,
    getPwlDetails: (registrationId: number) => Promise<IPwlDetailsResponse>,
    getLabOrder: (registrationId: number) => Promise<any>,
    getLabResultsNotCombined: (registrationId: number) => Promise<any>
    getLabResultsCombined: (registrationId: number) => Promise<any>,
    markJugAsArrived: (registrationId: number, arrivalDate: string) => Promise<IBaseResponse>,
    moveToBatch: (registrationId: number) => Promise<IBaseResponse>,
    uploadScrip: (registrationId: number, file: File, expirationDate: string) => Promise<IBaseResponse>,
    uploadLabs: (registrationId: number, file: File) => Promise<IUploadLabsResponse>,
    convertToDirectToCenter: (registrationId: number, centerId: number) => Promise<IBaseResponse>,
    markResultReviewed: (registrationId: number, centerId: number) => Promise<IBaseResponse>,
    restartPwl: (registrationId: number, isCystatinC: boolean) => Promise<IBaseResponse>,
    ruleOutPwl: (registrationId: number, centerId: number) => Promise<ICenterDashDetailResponse>,
    expireDonor: (registrationId: number, centerId: number) => Promise<ICenterDashDetailResponse>,
}

type TProps = IOwnProps & IStateProps & IDispatchProps;

const PwlDetails = (props: TProps) => {
    const [state, dispatch] = useReducer(pwlDetailsReducer, initialState);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        props.showLoading('Retrieving PWL details, one moment please...').then(() => {
            props.getPwlDetails(props.registrationId)
                .then(response => {
                    let { registrationDetails, pwlDetails, shippedJugsList, resultsUploadedList } = response.data.results;

                    dispatch({
                        type: 'afterLoad',
                        value: {
                            registrationDetails,
                            pwlDetails,
                            shippedJugsList,
                            resultsUploadedList
                        }
                    });
                })
                .finally(() => {
                    props.hideLoading();
                });
        });
    };

    const markJugArrivedSendEmail = () => {
        let data: IDonorRegistration = {
            id: 0,
            source: '',
            centerWorkflowId: 0,
            remoteStatus: null,
            onHoldStatusReason: null,
            remoteStatusDate: null,
            centerAlias: '',
            centerId: 0,
            fullName: '',
            addressLine1: '',
            donorCity: '',
            donorState: '',
            donorPostalCode: '',
            daysPending: 0,
            preWorkupLabStatus: '',
            labKitRequestId: '',
            phlebotTrackingId: '',
            isInExpertSystem: false,
            isExpertSystemParticipant: false,
            type: '',
            recipientLocation: '',
            location: '',
            milesFromCenter: null,
            email: '',
            phoneNumber: '',
            connectToDonorOffer: false,
            recipFullName: '',
            firstName: state.registrationDetails.firstName,
            lastName: state.registrationDetails.lastName,
            recipFirstName: '',
            recipLastName: '',
            recipDob: '',
            emailTemplate: '',
            emailSubject: '',
            donorConnectStatus: '',
            donorConnectRequested: false,
            donorConnectEmailSent: false,
            coordinatorId: 0,
            coordinator: {
                id: 0,
                fullName: ''
            },
            recipientCenterCoordinator: {
                id: 0,
                fullName: ''
            },
            recipientCoordinatorId: 0,
            recipientCenterCoordinatorPhone: '',
            logs: [],
            preWorkupLabDetails: undefined,
            isNkrUser: false,
            labFileUploaded: false,
            labJsonFileUploaded: false,
            labUploadedDateTime: '',
            scripUploadFile: false,
            preWorkupLabExists: false,
            currentRegistrationStep: 0,
            currentRegistrationStepStatus: '',
            preWorkupLabStep: 0,
            isRemoteDonor: false,
            donationType: 0,
            donationTypeDesc: 'Kidney',
            canAccessFollowUp: false,
            donorEditKey: '',
            dashDomain: '',
            isRepeat: false,
            hasFile: false,
            isOnHold: false,
            hasMicrositePatient: false,
            toDoStatus: '',
            hasUsedAlcohol: false,
            jugStatus: 0,
            jugStatusDesc: '',
            jugTrackingNumber: '',
            jugRequestedDate: '',
            jugShippedDate: '',
            jugArrivalDate: '',
            voucherEducationChoiceId: 0,
            closeLoopEntityType: 0,
            closeLoopEntityTypeDescription: '',
            closeLoopEntityTypeId: 0,
            closeLoopEpletMismatch: '',
            registrationDateTime: '',
            historyCompleteDateTime: '',
            dispositionRecordedDateTime: '',
            centerNextFollowUpDate: '',
            closeLoopSurgeryDateTime: '',
            closeLoopLinkedDonorType: 0,
            disposition: '',
            cancers: [],
            allergies: [],
            surgeries: [],
            medicines: [],
            isQuickStartDonor: false,
            remindersSent: 0,
            isInEmr: false,
            isClosed: false,
            emrRegistrationstring: '',
            emrCompletestring: '',
            preliminaryReviewstring: '',
            medicalReviewstring: '',
            closedstring: '',
            closedByUserId: 0,
            closedByUsername: '',
            expirestring: '',
            onHoldReason: 0,
            middleInitial: '',
            preferredName: '',
            phoneNumberSecondary: '',
            emergencyContact: '',
            emergencyContactPhone: '',
            emergencyContactRelationship: '',
            referralSource: '',
            isAdp: false,
            isNdd: false,
            voucherEducationChoice: 0,
            isAcceptable: false,
            ruleOutReasons: '',
            isCenterNotified: false,
            stopCommunication: false,
            timesCheckedIfContacted: 0,
            noContactReportstring: '',
            noContactReportDetails: '',
            workupScheduledstring: '',
            workupCompletedstring: '',
            preOpScheduledstring: '',
            preOpCompletedstring: '',
            surgeryScheduledstring: '',
            surgeryCompletedstring: '',
            isSurgeryScheduleConfirmed: false,
            isSurgeryConfirmed: false,
            gender: '',
            heightInches: 0,
            weightLbs: 0,
            isCurrentlyIncarcerated: false,
            isResidingInUsa: false,
            isAbleToGetToUsa: false,
            isDonatingForCompensation: false,
            willAcceptTransfusions: false,
            wasNutcrackerTreated: false,
            hasNutcracker: null,
            nutcrackerTreatment: '',
            hasHadOrganDisease: false,
            hasHadHeartAttack: false,
            heartAttackRemissionStatus: 0,
            hasDiabetes: false,
            diabetesStatus: '',
            hasHadCancer: false,
            hasHadKidneyDisease: false,
            hasHadKidneyStones: false,
            kidneyStoneEpisodes: 0,
            kidneyStoneRemissionStatus: '',
            kidneyStoneTreatment: '',
            hasBeenPregnant: false,
            isPregnant: false,
            monthsSincePregnant: 0,
            isNursing: false,
            hadGestationalDiabetes: false,
            isPlanningOnPregnancy: false,
            isTakingBirthControl: false,
            birthControlForm: '',
            birthControlMonths: 0,
            birthControlComplications: '',
            isAbleToStopBirthControl: false,
            preferredLanguage: '',
            isInterpreterNeeded: false,
            contactPreference: '',
            contactBestStartHour: '',
            contactBestEndHour: '',
            dlIssueState: 0,
            city: '',
            state: 0,
            postalCode: 0,
            countryOfResidence: '',
            dlIssueCountry: '',
            nonUsStateProvince: '',
            dlNonUsStateProvince: '',
            ssn: '',
            ssnDecrypted: '',
            dlNumber: '',
            dlNumberDecrypted: '',
            mothersMaiden: '',
            mothersMaidenDecrypted: '',
            passportNum: '',
            passportNumDecrypted: '',
            maritalStatus: '',
            ethnicity: '',
            employmentStatus: '',
            occupation: '',
            occupationHasHeavyLifting: false,
            medicalPto: '',
            annualIncomeRange: 0,
            wageReimbursementImportance: 0,
            qualifiesForCompensation: false,
            wantsWageReimbursement: false,
            wageReimbursementStep: '',
            wageReimbursementAmount: 0,
            wageReimbursementPaidDate: '',
            wageReimbursementDeclineReason: '',
            wageReimbursementReviewDueDate: '',
            wageReimbursementDocRequestDate: '',
            incomePayStubGross: 0,
            incomePayStubStartDate: '',
            incomePayStubEndDate: '',
            incomeIrsYearGross: 0,
            incomeIrsYear: 0,
            payStubFile: '',
            taxFile: '',
            totalReimbursementCount: 0,
            totalReimbursementAmount: 0,
            lastReimbursementDate: '',
            currentWeeklyGrossPay: 0,
            priorYearIncome: 0,
            connectToDonorAcceptedDate: '',
            connectToDonorAssignedUsername: '',
            connectToDonorAssignedFirstName: '',
            connectToDonorAssignedLastName: '',
            connectToDonorMilestone: '',
            connectToDonorMentor: '',
            educationLevel: '',
            exerciseRoutine: '',
            hasHealthInsurance: false,
            ddRecipFirstName: '',
            ddRecipLastName: '',
            ddKnowsRecipDob: false,
            ddRecipDob: '',
            ddRecipUrgency: '',
            ddAlternateDonationOptions: [],
            ddRelationshipToPatient: '',
            ddFrequencyOfCommunication: '',
            motivationToDonate: '',
            recipientCenterId: 0,
            recipientCenterName: '',
            recipientAtSameDashCenter: 0,
            recipientIsWillingToTransfer: 0,
            isHardshipToTravel: 0,
            isRemoteDonationPreferred: false,
            hasAllergies: false,
            hasHadSurgeries: false,
            takesMedication: false,
            physicianName: '',
            physicianCity: '',
            physicianState: 0,
            aboType: '',
            hasHistoryOfHighBp: '',
            highBpAgents: '',
            hadHighBpDuringPregnancy: '',
            hasHadCabg: '',
            hasHistoryOfBloodClots: '',
            hasHistoryOfCoronaryDisease: '',
            hasHistoryOfHighCholOrTg: '',
            hasStents: '',
            historyChestPainExercise: '',
            historyChestPainOther: '',
            resultsOfClimbingStairs: '',
            hadStressTestWithinYear: '',
            stressTestLocation: '',
            stressTestResults: '',
            hasHadStroke: '',
            howManyStrokes: 0,
            hasHadLegBypass: '',
            howManyLegBypasses: 0,
            historyLungDisease: '',
            hasCopd: '',
            hasTb: '',
            historyPneumonia: '',
            hasRespiratoryIssues: '',
            respiratoryIssuesDescription: '',
            hasHiv: '',
            hasGastroIssues: '',
            gastroIssuesDescription: '',
            historyGallstones: '',
            historyPancreatitis: '',
            historyLiverDisease: '',
            hasHepB: '',
            hasHepC: '',
            hasBleedingProblem: '',
            hasHadUti: '',
            utiEpisodes: 0,
            utiRemissionStatus: '',
            historyKidneyDamage: '',
            historyProteinuria: '',
            historyHematuria: '',
            historyNeuroDisease: '',
            historySeizure: '',
            hasLupus: '',
            historyParalysis: '',
            hasArthritis: '',
            historyNeuropathy: '',
            historyDepression: '',
            historyAnxiety: '',
            hasHistoryOfPsychiatric: '',
            psychiatricDescription: '',
            historyFibroidUterus: '',
            historyEndometriosis: '',
            historyPolycysticOvaries: '',
            hasHadMiscarriages: '',
            howManyMiscarriages: 0,
            hadLateMiscarriage: false,
            hasHadAbortions: '',
            howManyAbortions: 0,
            hasReceivedTransfusion: '',
            howManyTransfusions: 0,
            hasHistoryOfObesity: '',
            hasFabrys: '',
            hasSickleCell: '',
            hasSickleCellTrait: '',
            hasSarcoidosis: '',
            hasAutoImmune: '',
            autoImmuneDescription: '',
            lastPhysicalExam: '',
            hasHadPhysicalExam: '',
            physicalExamYearsAgo: 0,
            lastMammogram: '',
            hasHadMammogram: '',
            mammogramYearsAgo: 0,
            lastPapSmear: '',
            hasHadPapSmear: '',
            papSmearYearsAgo: 0,
            lastPsaTest: '',
            hasHadPsaTest: '',
            psaTestYearsAgo: 0,
            hasHadColonoscopy: '',
            additionalComments: '',
            visibilityComments: '',
            isTbActive: false,
            isHepBActive: false,
            familyHistoryKidneyDisease: '',
            familyMembersKidneyDisease: '',
            familyHistoryLiverDisease: '',
            familyMembersLiverDisease: '',
            familyHistoryHeartDisease: '',
            familyMembersHeartDisease: '',
            familyHistoryCad: '',
            familyMembersCad: '',
            familyHistoryBloodPressure: '',
            familyMembersBloodPressure: '',
            familyHistoryBloodDisorder: '',
            familyMembersBloodDisorder: '',
            familyHistoryCancer: '',
            familyMembersCancer: '',
            familyHistoryKidneyCancer: '',
            familyMembersKidneyCancer: '',
            familyHistoryDiabetes: '',
            familyMembersDiabetes: '',
            isMotherAlive: '',
            mothersLastAge: 0,
            motherCauseOfDeath: '',
            isFatherAlive: '',
            fathersLastAge: 0,
            fatherCauseOfDeath: '',
            howManySiblings: 0,
            howManyAdultChildren: 0,
            howManyUnderAgeChildren: 0,
            usesAlcohol: false,
            alcoholDrinks: 0,
            alcoholFrequency: '',
            hasAbusedAlcohol: false,
            hasUsedTobacco: false,
            tobaccoYears: 0,
            usesTobacco: false,
            willStopTobaccoUse: false,
            tobaccoPacks: 0,
            tobaccoFrequency: '',
            drugUse: '',
            hasUsedDrugs: false,
            hasBeenTreatedForDrugAbuse: false,
            drugUseHistory: [],
            drugsUsed: [],
            hasHadLegalIssues: false,
            hasBeenSentencedToPrison: false,
            prisonWhenAndWhere: '',
            hasTraveledLastYear: false,
            travelLocations: '',
            hasHadHighRiskSex: false,
            hasHadSexWithMmRelationsMale: false,
            hasHadMmSex: false,
            hasHadSexWithProstitute: false,
            hasProstituted: false,
            hasHadSexWithNeedleDrugUser: false,
            hasUsedNeedleDrugs: false,
            hasBeenInJailOver72: false,
            hasHadStd: false,
            hasBeenOnHemodialysis: false,
            hasHadSuicidalThoughtsAttempts: false,
            remoteCenterId: 0,
            expireDateTime: '',
            age: 0,
            stateProvinceString: '',
            bmi: 0,
            donorSituation: '',
            surveyNeededReimbursement: 0,
            birthDate: '',
            micrositeRecipient: undefined,
            remoteTransferType: '',
            closedDateTime: '',
            recipientCenterAlias: '',
            colonoscopyYearsAgo: 0,
            surgeryScheduledDateTime: '',
            reviewComments: '',
            donorStateId: 0,
            dispositionId: 0,
            hasHlaAlleleTyping: false,
            isExpertSystem: false,
            preWorkupLabStartDate: '',
            isLinkedToDonor: false,
            dashGambitData: null,
            isReadOnly: null,
            micrositeMatchQuality: {},
            recipientCenterIsNkrParticipant: false
        };

        dispatch({
            type: 'updateMarkJugArrivedSendEmail',
            value: {
                show: true,
                data,
                arrivalDate: moment().format('YYYY-MM-DD')
            }
        });
    };

    const getLabOrder = () => {
        props.getLabOrder(props.registrationId)
            .then(response => {
                downloadFile(response.data, 'lab-order.pdf', 'application/pdf');
            })
            .catch(() => {
                toast.error('We are unable to get the lab order file.');
            });
    };

    const getLabResultsCombined = () => {
        props.getLabResultsCombined(props.registrationId)
            .then(response => {
                downloadFile(response.data, 'lab-results.pdf', 'application/pdf');
            })
            .catch(() => {
                toast.error('We are unable to get the lab results file.');
            });
    };

    const getLabResultsNotCombined = () => {
        props.getLabResultsNotCombined(props.registrationId)
            .then(response => {
                downloadFile(response.data, 'lab-results.pdf', 'application/pdf');
            })
            .catch(() => {
                toast.error('We are unable to get the lab results file.');
            });
    };

    const handleAction = (e) => {
        if (e == PwlActions.Info) {

            let pwlLink = !props.isAdmin ? '/center/' + state.registrationDetails.centerId + '/donors/donor-intake/pwl/details/' + props.registrationId
                : '/admin/dash/donor-intake/pwl/details/' + props.registrationId;

            window.location.href = pwlLink;
        }

        if (e == PwlActions.MarkJugArrivedSendEmail) {
            markJugArrivedSendEmail();
        }

        if (e == PwlActions.ViewLabOrders) {
            getLabOrder();
        }

        if (e == PwlActions.ViewLabResults) {
            getLabResultsNotCombined();
        }

        if (e == PwlActions.ViewLabResultsDataGenerated) {
            getLabResultsCombined();
        }

        if (e == PwlActions.ReadyForLabOrder) {
            dispatch({
                type: 'updateShowReadyForLabs',
                value: true
            });
        }

        if (e == PwlActions.UploadScrip) {
            dispatch({
                type: 'updateShowUploadScrip',
                value: true
            });
        }

        if (e == PwlActions.UploadLabs) {
            dispatch({
                type: 'updateShowUploadLabResults',
                value: true
            });
        }

        if (e == PwlActions.ConvertDirectToCenter) {
            dispatch({
                type: 'updateShowConvertToDirectToCenter',
                value: true
            });
        }

        if (e == PwlActions.MarkResultsReviewed) {
            dispatch({
                type: 'updateShowMarkResultsReviewed',
                value: true
            });
        }

        if (e == PwlActions.RestartPwlJug) {
            dispatch({
                type: 'updateRestartPwl',
                value: {
                    show: true,
                    isCystatinC: false
                }
            });
        }

        if (e == PwlActions.RestartPwlCystatinC) {
            dispatch({
                type: 'updateRestartPwl',
                value: {
                    show: true,
                    isCystatinC: true
                }
            });
        }

        if (e == PwlActions.RuleOutCandidate) {
            dispatch({
                type: 'updateShowRuleOut',
                value: true
            });
        }

        if (e == PwlActions.ExpireDonor) {
            dispatch({
                type: 'updateShowExpireDonor',
                value: true
            });
        }
    };

    const handleMarkJugArrivedDateChange = (arrivalDate: string) => {
        let value = { ...state.markJugArrived, arrivalDate };

        dispatch({
            type: 'updateMarkJugArrivedSendEmail',
            value
        });
    };

    const handleMarkJugArrivedConfirm = () => {
        let donorReg = state.markJugArrived.data;
        let arrivalDate = state.markJugArrived.arrivalDate;

        props.showLoading('Updating Jug Information, one moment please...').then(() => {
            props.markJugAsArrived(donorReg.id, arrivalDate)
                .then(response => {
                    if (response.data.success) {
                        dispatch({
                            type: 'updateMarkJugArrivedSendEmail',
                            value: {
                                show: false,
                                data: null,
                                arrivalDate: moment().format("YYYY-MM-DD")
                            }
                        });

                        toast.success('Jug marked as arrived. Email sent successfully.');
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error("Unable to complete request: " + error.response.data);
                })
                .finally(() => {
                    props.hideLoading();
                });
            ;
        });
    };

    const handleMarkJugArrivedCancel = () => {
        dispatch({
            type: 'updateMarkJugArrivedSendEmail',
            value: {
                show: false,
                data: null,
                arrivalDate: ''
            }
        });
    }

    const handleConfirmReadyForLabs = () => {
        props.showLoading('Changing status, one moment please...').then(() => {
            props.moveToBatch(props.registrationId)
                .then(response => {
                    if (response.data.success) {
                        dispatch({
                            type: 'updateShowReadyForLabs',
                            value: false
                        });

                        toast.success('Status changed successfully.');
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error("Unable to complete request: " + error.response.data);
                })
                .finally(() => {
                    props.hideLoading();
                });
            ;
        });
    };

    const handleCancelReadyForLabs = () => {
        dispatch({
            type: 'updateShowReadyForLabs',
            value: false
        });
    };

    const handleUploadScrip = (file: File, expirationDate: string) => {
        props.showLoading('Uploading scrip, one moment please...').then(() => {
            props.uploadScrip(props.registrationId, file, expirationDate)
                .then(response => {
                    if (response.data.success) {
                        dispatch({
                            type: 'updateShowUploadScrip',
                            value: false
                        });

                        toast.success('Scrip uploaded successfully.');
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error("Unable to complete request: " + error.response.data);
                })
                .finally(() => {
                    props.hideLoading();
                });
            ;
        });
    };

    const handleCancelUploadScrip = () => {
        dispatch({
            type: 'updateShowUploadScrip',
            value: false
        });
    };

    const handleUploadLabReults = (file: File) => {
        props.showLoading('Uploading lab results, one moment please...').then(() => {
            props.uploadLabs(props.registrationId, file)
                .then(response => {
                    if (response.data.success) {
                        dispatch({
                            type: 'updateShowUploadLabResults',
                            value: false
                        });

                        toast.success('Lab results uploaded successfully.');
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error("Unable to complete request: " + error.response.data);
                })
                .finally(() => {
                    props.hideLoading();
                });
            ;
        });
    };

    const handleCancelUploadLabResults = () => {
        dispatch({
            type: 'updateShowUploadLabResults',
            value: false
        });
    };

    const handleConfirmConvertToDirectToCenter = () => {
        props.showLoading('Changing status, one moment please...').then(() => {
            props.convertToDirectToCenter(props.registrationId, props.centerId)
                .then(response => {
                    if (response.data.success) {
                        dispatch({
                            type: 'updateShowConvertToDirectToCenter',
                            value: false
                        });

                        toast.success('Status changed successfully.');
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error("Unable to complete request: " + error.response.data);
                })
                .finally(() => {
                    props.hideLoading();
                });
            ;
        });
    };

    const handleCancelConvertToDirectToCenter = () => {
        dispatch({
            type: 'updateShowConvertToDirectToCenter',
            value: false
        });
    };

    const handleConfirmMarkResultsReviewed = () => {
        props.showLoading('Changing status, one moment please...').then(() => {
            props.markResultReviewed(props.registrationId, props.centerId)
                .then(response => {
                    if (response.data.success) {
                        dispatch({
                            type: 'updateShowMarkResultsReviewed',
                            value: false
                        });

                        toast.success('Status changed successfully.');
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error("Unable to complete request: " + error.response.data);
                })
                .finally(() => {
                    props.hideLoading();
                });
            ;
        });
    };

    const handleCancelMarkResultsReviewed = () => {
        dispatch({
            type: 'updateShowMarkResultsReviewed',
            value: false
        });
    };

    const handleConfirmRestartPwl = () => {
        props.showLoading('Changing status, one moment please...').then(() => {
            props.restartPwl(props.registrationId, state.restartPwl.isCystatinC)
                .then(response => {
                    if (response.data.success) {
                        dispatch({
                            type: 'updateRestartPwl',
                            value: false
                        });

                        toast.success('Status changed successfully.');
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error("Unable to complete request: " + error.response.data);
                })
                .finally(() => {
                    props.hideLoading();
                });
            ;
        });
    };

    const handleCancelRestartPwl = () => {
        dispatch({
            type: 'updateRestartPwl',
            value: false
        });
    };

    const handleConfirmRuleOut = () => {
        props.showLoading('Changing status, one moment please...').then(() => {
            props.ruleOutPwl(props.registrationId, props.centerId)
                .then(response => {
                    if (response.data.success) {
                        dispatch({
                            type: 'updateShowRuleOut',
                            value: false
                        });

                        toast.success('Status changed successfully.');

                        getData();
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error("Unable to complete request: " + error.response.data);
                })
                .finally(() => {
                    props.hideLoading();
                });
            ;
        });
    };

    const handleCancelRuleOut = () => {
        dispatch({
            type: 'updateShowRuleOut',
            value: false
        });
    };

    const handleConfirmExpireDonor = () => {
        props.showLoading('Changing status, one moment please...').then(() => {
            props.expireDonor(props.registrationId, props.centerId)
                .then(response => {
                    if (response.data.success) {
                        dispatch({
                            type: 'updateShowExpireDonor',
                            value: false
                        });

                        getData();

                        toast.success('Status changed successfully.');
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error("Unable to complete request: " + error.response.data);
                })
                .finally(() => {
                    props.hideLoading();
                });
            ;
        });
    };

    const handleCancelExpireDonor = () => {
        dispatch({
            type: 'updateShowExpireDonor',
            value: false
        });
    };

    if (state.registrationDetails == null || state.pwlDetails == null)
        return null;

    let isAdmin = props.groupIsSuper && (props.isAdmin);

    let menuItems: { key: number, label: string, show: boolean }[] = [
        { key: PwlActions.Info, label: 'Info', show: true },
        { key: PwlActions.MarkJugArrivedSendEmail, label: 'Mark Jug-Arrived / Send Email', show: state.pwlDetails.preWorkupLabStepId >= PreWorkupLabStep.JugShipped && state.pwlDetails.jugStatusId < PreWorkupLabJugStatus.Received && isAdmin },
        { key: PwlActions.ReadyForLabOrder, label: 'Ready for Lab Order', show: [PreWorkupLabStep.JugShipped, PreWorkupLabStep.JugGetOwn, PreWorkupLabStep.PendingLabs, PreWorkupLabStep.LabChoice].indexOf(state.pwlDetails.preWorkupLabStepId) >= 0 && isAdmin },
        { key: PwlActions.UploadScrip, label: 'Upload Scrip', show: [PreWorkupLabStep.QuestPendingScrip, PreWorkupLabStep.PhlebotPendingScrip].indexOf(state.pwlDetails.preWorkupLabStepId) >= 0 && isAdmin },
        { key: PwlActions.UploadLabs, label: 'Upload Lab Results', show: ([PreWorkupLabStep.PhlebotScripUploaded, PreWorkupLabStep.PhlebotScripDownloaded].indexOf(state.pwlDetails.preWorkupLabStepId) >= 0 || state.pwlDetails.preWorkupLabStepId >= PreWorkupLabStep.QuestScripUploaded) && isAdmin },
        { key: PwlActions.ConvertDirectToCenter, label: 'Convert - Direct to Center', show: isAdmin },
        { key: 5.5, label: '', show: state.pwlDetails.scripUploadFile != '' || state.pwlDetails.labsUploadFile != '' },
        { key: PwlActions.ViewLabOrders, label: 'View Lab Orders', show: state.pwlDetails.scripUploadFile != '' },
        { key: PwlActions.ViewLabResults, label: 'View Lab Results', show: state.pwlDetails.labsUploadFile != '' },
        { key: PwlActions.ViewLabResultsDataGenerated, label: 'View Lab Results (Data Generated)', show: state.pwlDetails.labsUploadFile != '' && state.pwlDetails.labsUploadFileJson != '' },
        { key: PwlActions.MarkResultsReviewed, label: 'Mark Results Reviewed', show: state.pwlDetails.labsUploadFile != '' && state.pwlDetails.labResultsAreReviewed },
        { key: PwlActions.RestartPwlJug, label: 'Restart PWL (Jug)', show: isAdmin },
        { key: PwlActions.RestartPwlCystatinC, label: 'Restart PWL (Cystatin C)', show: isAdmin },
        { key: 12.5, label: '', show: true },
        { key: PwlActions.RuleOutCandidate, label: 'Rule-Out Candidate', show: state.registrationDetails.isClosed == false },
        { key: PwlActions.ExpireDonor, label: 'Expire Donor', show: true },
    ];

    let menuItemsToDisplay = menuItems.filter(x => x.show);

    return (
        <>
            <div className='container'>
                <div style={{ marginBottom: 5, textAlign: 'right' }}>
                    <DropdownButton block bsStyle='primary' title='Available Actions' id='pwl-actions' onSelect={handleAction}>
                        {menuItemsToDisplay.map(item => {
                            if (item.label == '') {
                                return <MenuItem divider />
                            } else {
                                return <MenuItem eventKey={item.key}>{item.label}</MenuItem>
                            }
                        })}
                    </DropdownButton>
                </div>

                <Panel>
                    <Panel.Heading>Jug Shipment Details</Panel.Heading>
                    {state.shippedJugsList.length > 0 &&
                        <TableWrapper striped bordered condensed>
                            <thead>
                                <tr style={{ backgroundColor: '#ddd' }}>
                                    <th>Requested</th>
                                    <th>Shipped</th>
                                    <th>Arrived</th>
                                    <th>Reported Not Found</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.shippedJugsList.map(item =>
                                    <>
                                        {item.requestedDateTime == '' ?
                                            <tr>
                                                <td>{item.shippedDateTime}</td>
                                                <td>--</td>
                                                <td>{item.arrivalDateTime}</td>
                                                <td>{item.notFoundDateTime}</td>
                                                <td>{item.status}</td>
                                            </tr>
                                            :
                                            <tr>
                                                <td>{item.requestedDateTime}</td>
                                                <td>{item.shippedDateTime}</td>
                                                <td>{item.arrivalDateTime}</td>
                                                <td>{item.notFoundDateTime}</td>
                                                <td>{item.status}</td>
                                            </tr>
                                        }
                                    </>
                                )}
                            </tbody>
                        </TableWrapper>
                    }
                    <Panel.Body>
                        <Row>
                            <Col xs={6} sm={3}><strong>Jug Shipment Status:</strong></Col>
                            <Col xs={6} sm={3}>{state.pwlDetails.jugStatus}</Col>
                            <Col xs={6} sm={3}><strong>Date of Donor Receipt:</strong></Col>
                            <Col xs={6} sm={3}>{state.pwlDetails.jugReceivedDateTime != '' ? state.pwlDetails.jugReceivedDateTime : <Label>Not Yet Confirmed</Label>}</Col>
                        </Row>
                    </Panel.Body>
                </Panel>

                <Panel>
                    <Panel.Heading>Lab Order Details</Panel.Heading>
                    <Panel.Body>
                        <Row>
                            <Col xs={6} sm={3}><strong>Lab Orders Created:</strong></Col>
                            <Col xs={6} sm={3}>{state.pwlDetails.scripUploadDateTime}</Col>
                            <Col xs={6} sm={3}><strong>Lab Orders Expire On:</strong></Col>
                            <Col xs={6} sm={3}>{state.pwlDetails.scripExpirationDate}</Col>
                        </Row>
                        {state.pwlDetails.questCompletedDate != '' && (
                            <>
                                <Row>
                                    <h4 className='text-center'>Missing Quest Labs Details</h4>
                                </Row>
                                <div className='alert alert-danger'>This donor reported that they have already completed labs at Quest w/ the following info:</div>
                                <Row>
                                    <Col xs={6} sm={3}><strong>When?</strong></Col>
                                    <Col xs={6} sm={3}>{state.pwlDetails.questCompletedDate}</Col>
                                    <Col xs={6} sm={3}><strong>Where?</strong></Col>
                                    <Col xs={6} sm={3}>{state.pwlDetails.questCompletedWhere}</Col>
                                </Row>
                            </>
                        )}
                    </Panel.Body>
                </Panel>

                <Panel>
                    <Panel.Heading>Results Uploaded Details</Panel.Heading>
                    <TableWrapper striped bordered condensed>
                        <thead>
                            <tr style={{ backgroundColor: '#ddd' }}>
                                <th>Requisition Number</th>
                                <th>Uploaded</th>
                                <th>Is Billable?</th>
                            </tr>
                        </thead>
                        <tbody>
                            {state.resultsUploadedList.map(item =>
                                <tr>
                                    <td>{item.requisitionNumber == '' ? state.pwlDetails.labOrderRequisitionNumber : item.requisitionNumber}</td>
                                    <td>{item.uploadDateTime}</td>
                                    <td>{item.isBillable ? <Label bsStyle='success'>Yes</Label> : <Label>No</Label>}</td>
                                </tr>
                            )}
                        </tbody>
                    </TableWrapper>
                </Panel>

                <Panel>
                    <Panel.Heading>Registration Details</Panel.Heading>
                    <Panel.Body>
                        <Row>
                            <Col xs={6} sm={3}><strong>Registered:</strong></Col>
                            <Col xs={6} sm={3}>{state.registrationDetails.registrationDateTime}</Col>
                            <Col xs={6} sm={3}><strong>Referred:</strong></Col>
                            <Col xs={6} sm={3}>{state.registrationDetails.historyCompleteDateTime}</Col>
                        </Row>
                        <Row>
                            <Col xs={6} sm={3}><strong>First Name:</strong></Col>
                            <Col xs={6} sm={3}>{state.registrationDetails.firstName}</Col>
                            <Col xs={6} sm={3}><strong>Last Name:</strong></Col>
                            <Col xs={6} sm={3}>{state.registrationDetails.lastName}</Col>
                        </Row>
                        <Row>
                            <Col xs={6} sm={3}><strong>Email:</strong></Col>
                            <Col xs={6} sm={3} style={{ overflow: 'clip', textOverflow: 'ellipsis' }}><a href={'mailto:' + state.registrationDetails.email}>{state.registrationDetails.email}</a></Col>
                            <Col xs={6} sm={3}><strong>Phone Number:</strong></Col>
                            <Col xs={6} sm={3}>{state.registrationDetails.phoneNumber}</Col>
                        </Row>
                        <Row>
                            <Col xs={6} sm={3}><strong>DOB:</strong></Col>
                            <Col xs={6} sm={3}>{state.registrationDetails.birthDate}</Col>
                            <Col xs={6} sm={3}><strong>Age:</strong></Col>
                            <Col xs={6} sm={3}>{state.registrationDetails.age}</Col>
                        </Row>
                        <Row>
                            <Col xs={6} sm={3}><strong>Address:</strong></Col>
                            <Col xs={6} sm={3}>{state.registrationDetails.addressLine1}</Col>
                            <Col xs={6} sm={3}><strong>City:</strong></Col>
                            <Col xs={6} sm={3}>{state.registrationDetails.city}</Col>
                        </Row>
                        <Row>
                            <Col xs={6} sm={3}><strong>State:</strong></Col>
                            <Col xs={6} sm={3}>{state.registrationDetails.state}</Col>
                            <Col xs={6} sm={3}><strong>Postal Code:</strong></Col>
                            <Col xs={6} sm={3}>{state.registrationDetails.postalCode}</Col>
                        </Row>
                        <Row>
                            <Col xs={6} sm={3}><strong>Height:</strong></Col>
                            <Col xs={6} sm={3}>{state.registrationDetails.heightSubFeet}'{state.registrationDetails.heightSubInches}"</Col>
                            <Col xs={6} sm={3}><strong>Weight:</strong></Col>
                            <Col xs={6} sm={3}>{state.registrationDetails.weightLbs} lbs</Col>
                        </Row>
                    </Panel.Body>
                    {state.registrationDetails.hasIntendedRecipient ?
                        <Alert bsStyle={state.registrationDetails.recipientLocationId == 1 ? 'info' : 'warning'} style={{ marginBottom: 0 }}>
                            <h3 style={{ marginTop: 0 }}>Donating for {state.registrationDetails.recipientLocation}</h3>
                            {state.registrationDetails.recipientLocationId == 1 && (
                                <Row>
                                    <Col xs={6} sm={2}><strong>Center:</strong></Col>
                                    <Col xs={6} sm={10}>{state.registrationDetails.recipientCenter}</Col>
                                </Row>
                            )}
                            <Row>
                                <Col xs={6} sm={2}><strong>Name:</strong></Col>
                                <Col xs={6} sm={3}>{state.registrationDetails.ddRecipientFirstName} {state.registrationDetails.ddRecipientLastName}</Col>
                                <Col xs={6} sm={1}><strong>DOB:</strong></Col>
                                <Col xs={6} sm={2}>{state.registrationDetails.ddKnowsRecipientDob ? state.registrationDetails.ddRecipientDob : 'Doesn\t Know'}</Col>
                                <Col xs={6} sm={2}><strong>Relationship:</strong></Col>
                                <Col xs={6} sm={2}>{state.registrationDetails.ddRelationshipToPatient}</Col>
                            </Row>
                            <Row>
                                <Col xs={6} sm={2}><strong>Status:</strong></Col>
                                <Col xs={6} sm={10}>{state.registrationDetails.ddRecipientUrgency}</Col>
                            </Row>
                            <Row>
                                <Col xs={6} sm={2}><strong>Communicates:</strong></Col>
                                <Col xs={6} sm={10}>{state.registrationDetails.ddFrequencyOfCommunication}</Col>
                            </Row>
                        </Alert>
                        :
                        <Alert bsStyle='info'>{state.registrationDetails.donorSituation}</Alert>
                    }
                </Panel>
            </div>

            <MarkJugArrivedSendEmail
                show={state.markJugArrived.show}
                formData={state.markJugArrived.data}
                arrivalDate={state.markJugArrived.arrivalDate}
                onDateChange={handleMarkJugArrivedDateChange}
                onConfirm={handleMarkJugArrivedConfirm}
                onCancel={handleMarkJugArrivedCancel} />

            <ReadyForLabsModal
                show={state.showReadyForLabs}
                fullName={state.registrationDetails.firstName + ' ' + state.registrationDetails.lastName}
                onConfirm={handleConfirmReadyForLabs}
                onCancel={handleCancelReadyForLabs} />

            <UploadScrip
                show={state.showUploadScrip}
                fullName={state.registrationDetails.firstName + ' ' + state.registrationDetails.lastName}
                onSubmit={handleUploadScrip}
                onCancel={handleCancelUploadScrip} />

            <UploadLabResults
                show={state.showUploadLabResults}
                fullName={state.registrationDetails.firstName + ' ' + state.registrationDetails.lastName}
                onSubmit={handleUploadLabReults}
                onCancel={handleCancelUploadLabResults} />

            <ConvertToDirectToCenterModal
                show={state.showConvertToDirectToCenter}
                fullName={state.registrationDetails.firstName + ' ' + state.registrationDetails.lastName}
                onConfirm={handleConfirmConvertToDirectToCenter}
                onCancel={handleCancelConvertToDirectToCenter} />

            <MarkResultsReviewedModal
                show={state.showMarkResultsReviewed}
                fullName={state.registrationDetails.firstName + ' ' + state.registrationDetails.lastName}
                onConfirm={handleConfirmMarkResultsReviewed}
                onCancel={handleCancelMarkResultsReviewed} />

            <RestartPwlModal
                show={state.restartPwl.show}
                fullName={state.registrationDetails.firstName + ' ' + state.registrationDetails.lastName}
                isCystatinC={state.restartPwl.isCystatinC}
                onConfirm={handleConfirmRestartPwl}
                onCancel={handleCancelRestartPwl} />

            <RuleOutModal
                show={state.showRuleOut}
                fullName={state.registrationDetails.firstName + ' ' + state.registrationDetails.lastName}
                onConfirm={handleConfirmRuleOut}
                onCancel={handleCancelRuleOut} />

            <ExpireDonorModal
                show={state.showExpireDonor}
                fullName={state.registrationDetails.firstName + ' ' + state.registrationDetails.lastName}
                onConfirm={handleConfirmExpireDonor}
                onCancel={handleCancelExpireDonor} />
        </>
    );
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        groupIsSuper: appState.app.user.group.isSuper
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getPwlDetails: (registrationId) => {
            return dispatch(DashCenterActionCreators.getPwlDetails(registrationId));
        },
        getLabOrder: (registrationId) => {
            return dispatch(DashCenterActionCreators.getLabOrder(registrationId));
        },
        getLabResultsNotCombined: (registrationId) => {
            return dispatch(DashCenterActionCreators.getLabResultsNotCombined(registrationId));
        },
        getLabResultsCombined: (registrationId) => {
            return dispatch(DashCenterActionCreators.getLabResultsCombined(registrationId));
        },
        markJugAsArrived: (registrationId, arrivalDate) => {
            return dispatch(DashCenterActionCreators.markJugAsArrived(registrationId, arrivalDate));
        },
        moveToBatch: (registrationId) => {
            return dispatch(DashCenterActionCreators.moveToBatch(registrationId));
        },
        uploadScrip: (registrationId, file, expirationDate) => {
            return dispatch(DashCenterActionCreators.uploadScrip(registrationId, file, expirationDate));
        },
        uploadLabs: (registrationId, file) => {
            return dispatch(DashCenterActionCreators.uploadLabs(registrationId, file));
        },
        convertToDirectToCenter: (registrationId, centerId) => {
            return dispatch(DashCenterActionCreators.convertToDirectToCenter(registrationId, centerId));
        },
        markResultReviewed: (registrationId, centerId) => {
            return dispatch(DashCenterActionCreators.markResultsReviewed(registrationId, centerId));
        },
        restartPwl: (registrationId, isCystatinC) => {
            return dispatch(DashCenterActionCreators.restartPwl(registrationId, isCystatinC));
        },
        ruleOutPwl: (registrationId, centerId) => {
            return dispatch(DashCenterActionCreators.ruleOutPwl(registrationId, centerId));
        },
        expireDonor: (registrationId, centerId) => {
            return dispatch(DashCenterActionCreators.expireDonor(registrationId, centerId));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(PwlDetails);